import PlayerInterface from "../Interfaces/PlayerInterface";
import GameInterface from "../Interfaces/GameInterface";

export default class Player implements PlayerInterface
{
    left: number;
    bottom: number;
    speed: number = 20;
    player: HTMLElement;

    game: GameInterface;
    alive: boolean = true;

    constructor()
    {
        this.left = 0;
        this.bottom = 0;
        document.body.onkeydown = (e) => {
            if(!this.alive) {
                return;
            }
            this.player.classList.add('active');
            if(e.keyCode == 38) {
                this.moveUp();
                return;
            }
            if(e.keyCode == 39) {
                this.moveRight();
                return;
            }
            if(e.keyCode == 40) {
                this.moveDown();
                return;
            }
            if(e.keyCode == 37) {
                this.moveLeft();
                return;
            }
        }

        this.player = document.createElement('div');
        this.player.id = 'Player';
        this.player.classList.add('base');
        document.getElementById('Game').addEventListener('GameOver', () => {
            this.alive = false;
        });
    }

    render(): HTMLElement
    {
        return this.player;
    }

    moveUp()
    {
        if((this.bottom + this.speed) + this.player.offsetHeight > window.innerHeight) {
            return;
        }
        this.bottom = this.bottom + this.speed;
        this.player.style.bottom = this.bottom.toString() + 'px';
        this.checkPosition();
    }

    moveRight()
    {
        if((this.left + this.speed) + this.player.offsetWidth > window.innerWidth) {
            return;
        }
        this.left = this.left + this.speed;
        this.player.style.left = this.left.toString() + 'px';
        this.checkPosition();
        this.player.classList.remove('left');
        this.player.classList.add('right');
    }

    moveDown()
    {
        if((this.bottom - this.speed) < 0) {
            return;
        }
        this.bottom = this.bottom - this.speed;
        this.player.style.bottom = this.bottom.toString() + 'px';
        this.checkPosition();
    }

    moveLeft()
    {
        if((this.left - this.speed) < 0) {
            return;
        }
        this.left = this.left - this.speed;
        this.player.style.left = this.left.toString() + 'px';
        this.checkPosition();
        this.player.classList.remove('right');
        this.player.classList.add('left');
    }

    checkPosition()
    {
        setTimeout(() => {
            this.player.classList.remove('active');
        }, 200);
        let playerPos = this.player.getBoundingClientRect();
        this.game.elements.forEach( (e) => {
            let objPos = e.getBoundingClientRect();

            if (!(  playerPos.right  < objPos.left   ||
                    playerPos.left   > objPos.right  ||
                    playerPos.bottom < objPos.top    ||
                    playerPos.top    > objPos.bottom)
                ) {
                    e.dispatchEvent(new CustomEvent('PlayerInteraction'));
            }
        });
    }

    setGame(game: GameInterface): void
    {
        this.game = game;
    }
}
